import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-master-crud-update',
  templateUrl: './master-crud-update.component.html',
  styleUrls: ['./master-crud-update.component.scss']
})
export class MasterCrudUpdateComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  imgURL: any = "";
  public CurrentDetail:any=[];
  public CurrentUrl:any=this.router.url;
  public answerId:any='';
  

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) {
    this.CurrentDetail= JSON.parse(localStorage.getItem('hva_content')||'{}')
      this.imgURL= this.CurrentDetail.icon;
  }

  ngOnInit(): void {
  }


  Onsubmit(){
    this.submitted = true;    
       var url:any='';
       var detail:any={};
       let formdata= new FormData();
       if(this.CurrentUrl == '/update-generation' ){
        url='/age-master/'+ this.CurrentDetail._id;
       } else {
        url='/answer/'+ this.answerId;
       }
        this.loading=true; 
       if(this.imgURL == ''){
         this.service.dangerAlert('Please upload the image');
         return
       } else {
         if(this.selectedFile!=''){
           formdata.append('icon',this.selectedFile);
         }
       } 
       this.service.updateFormData1(formdata,url).subscribe(((response:any)=>{
        if(response.success ==1){         
          this.submitted = false;  
          this.loading=false;  
          this.service.back();
        } else {
          this.service.dangerAlert(response.message);
          this.loading=false;
        }
      }), (error:any) => {
        this.loading=false;
      });
    }


  getUploadFileDetail(event: any,type:any) {
    //this.imageChangedEvent = event;
    if (event.target.files.length > 0) {
      this.selectedFile = event.target.files[0];
      var mimeType = event.target.files[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.service.dangerAlert("Only images are supported.");
        return;
      }
      var reader = new FileReader();
      this.imagePath = event.target.files;
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (_event) => {
        this.imgURL = reader.result;
        if(type==2){          
          this.Onsubmit();
        }
      };
    }
  }
  
  changeImage() {
    $("#file1").trigger("click");
  }
}
